export interface LoadingSlice {
    isLoading: boolean;
    setLoading: (loading: boolean) => void;
    loadingCount: number; // Track multiple loading operations
    startLoading: () => void;
    stopLoading: () => void;
}

export const createLoadingSlice = (set: any): LoadingSlice => ({
    isLoading: false,
    loadingCount: 0,

    setLoading: (loading: boolean) =>
        set(() => ({
            isLoading: loading,
            loadingCount: loading ? 1 : 0,
        })),

    startLoading: () =>
        set((state) => {
            const newCount = state.loadingCount + 1;
            return {
                loadingCount: newCount,
                isLoading: newCount > 0,
            };
        }),

    stopLoading: () =>
        set((state) => {
            const newCount = Math.max(0, state.loadingCount - 1);
            return {
                loadingCount: newCount,
                isLoading: newCount > 0,
            };
        }),
});
